import { StyleSheet } from 'aphrodite'

const styles = StyleSheet.create({
  thumbnailContainer: {
    display: 'block',
    position: 'relative',
    height: 170,
    width: 170,
    minHeight: 170,
    minWidth: 170
  },
  thumbnail: {
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    border: 'none',
    display: 'block',
    height: 170,
    width: 170,
    minHeight: 170,
    minWidth: 170,
    position: 'absolute',
    top: 0,
    padding: 0,
    userSelect: 'none'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Media/File/Thumbnail/styles.js